const TUISearch = {
  搜索: "搜索",
  全部: "全部",
  联系人: "聯繫人",
  群聊: "群聊",
  聊天记录: "聊天記錄",
  文本: "文本",
  文件: "文件",
  "图片/视频": "圖片/視頻",
  其他: "其他",
  选择时间: "選擇時間",
  今天: "今天",
  近三天: "近三天",
  近七天: "近七天",
  查看更多: "查看更多",
  条相关: "條相關",
  条与: "條與",
  相关的: "相關的",
  进入聊天: "進入聊天",
  定位到聊天位置: "定位到聊天位置",
  搜索会话内容: "搜索會話內容",
  查看更多历史记录: "查看更多歷史記錄",
  暂无搜索结果: "暫無搜索結果",
  结果: "結果",
  取消: "取消",
  "[文本]": "[文本]",
  "[图片]": "[圖片]",
  "[语音]": "[語音]",
  "[视频]": "[視頻]",
  "[文件]": "[文件]",
  "[自定义消息]": "[自定義消息]",
  "[系统消息]": "[系統消息]",
  "[合并消息]": "[合併消息]",
  "[位置消息]": "[位置消息]",
  "消息云端搜索失败：": "消息雲端搜索失敗：",
  "查找联系人失败：": "查找聯繫人失敗：",
  "查找群聊失败：": "查找群聊失敗：",
  "进入会话失败": "進入會話失敗",
};

export default TUISearch;
